import { get } from 'lodash';
import React from 'react';
import { FORM_WIDGET_COMPONENTS } from '../../../form/formConstants';
import FormWidget from '../../../form/FormWidget';
import { useI18n } from '../../../i18n/I18n';
import { SCHEDULE_FORM_WIDGET_FIELD_NAMES } from '../constants';
import useScheduleFormWidgetContext from '../useScheduleFormWidgetContext';
import { resolveStateFieldName } from '../utils/form-utils';

export interface ScheduleDurationValueFormWidgetProps {
    name?: string;
    disabled?: boolean;
}

export default function ScheduleDurationValueFormWidget({
    name: nameProp,
    disabled: disabledProp
}: ScheduleDurationValueFormWidgetProps) {
    const t = useI18n();

    const { loading, error, disabled, getFormStateByFieldName } = useScheduleFormWidgetContext();

    const name = resolveStateFieldName([nameProp, SCHEDULE_FORM_WIDGET_FIELD_NAMES.DURATION_VALUE]);

    const durationSpecifiedFieldName = resolveStateFieldName([
        nameProp,
        SCHEDULE_FORM_WIDGET_FIELD_NAMES.DURATION_SPECIFIED
    ]);
    const isDurationSpecified = getFormStateByFieldName(durationSpecifiedFieldName) as boolean;

    const isWidgetDisabled = disabled || disabledProp || loading || !isDurationSpecified;

    const widgetErrors = get(error, name);

    return (
        <FormWidget
            component={FORM_WIDGET_COMPONENTS.number}
            label={t('scheduleFormWidget.duration.label')}
            name={name}
            disabled={isWidgetDisabled}
            hasErrors={Boolean(widgetErrors)}
            errors={widgetErrors}
            decimals={2}
            forcePositive
            useGrouping={false}
        />
    );
}
